var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJuniperChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.994.251a.857.857 0 0 1 1.212 0L12.74 10.786a1.68 1.68 0 0 1 0 2.428L2.206 23.749a.857.857 0 1 1-1.212-1.212L11.53 12 .993 1.463a.857.857 0 0 1 0-1.212Z",
    fill: "#133F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuniperChevronRight);
export default __webpack_public_path__ + "static/media/juniper-chevron-right.760153242ff11de8bc6c8d18d4fcc5ec.svg";
export { ForwardRef as ReactComponent };